// ===========================================
// Announcements.js
// 童顏家行程日曆系統 - 最新公告元件
//
// 版本：V1.01 | 2024-07-05 20:10:00
// 主要功能：顯示最新公告內容
// 解決問題：讓用戶即時看到重要公告
//
// 版本紀錄：
// - V1.01 (2024-07-05): 初始版本，從 App.js 拆分
//
// 注意事項：
// - 僅顯示一則最新公告
// - 關聯檔案：App.js
// ===========================================
import React from 'react';

const Announcements = ({ announcements }) => {
    const limitedAnnouncements = announcements.slice(0, 1);
    if (limitedAnnouncements.length === 0) return null;
    return (
        <div className="mb-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 rounded-r-md" role="alert">
            <p className="font-bold">最新公告</p>
            <p className="text-sm">{limitedAnnouncements[0].content}</p>
        </div>
    );
};

export default Announcements; 